export default __webpack_public_path__ + "static/media/GeorgiaTech.1b0187fd.jpg";